import VueDraggable from 'vuedraggable';
import DragItemContent from '../BasicComps/DragItemContent.vue';
import { getCatList, queryAllPropertyClassify, queryBrandListAll } from '@/api/supplier/erpIndex';
import { mapState } from 'vuex';

export const dragItemMixin = {
  components: {
    VueDraggable,
    DragItemContent,
  },
};

const cascaderProps = {
  multiple: true,
  checkStrictly: true,
  expandTrigger: 'hover',
  emitPath: false,
};

// 商品分类 商品类目 商品品牌
export const goodsPropsMixin = {
  data() {
    return {
      propertyClassifyList: [],
      goodsClassifyList: [],
      brandList: [],
    };
  },

  computed: {
    propertyProps() {
      return {
        value: 'id',
        label: 'name',
        children: 'childIdPropertyClassifyList',
        ...cascaderProps,
      };
    },
    goodsProps() {
      return {
        value: 'cid',
        label: 'name',
        ...cascaderProps,
      };
    },
    cascaderComb({ propertyClassifyList, propertyProps, goodsProps, goodsClassifyList }) {
      const attrs = { clearable: true, /*  filterableShowValue: true, */ filterable: true, 'collapse-tags': true };
      return {
        catIds: { props: propertyProps, options: propertyClassifyList, placeholder: '商品类目', ...attrs },
        cIds: { props: goodsProps, options: goodsClassifyList, placeholder: '商品分类', ...attrs },
      };
    },
  },
  methods: {
    // 商品分类
    reqPropertyClassify(params = {}) {
      return queryAllPropertyClassify(params);
    },
    async getPropertyClassify() {
      const res = await this.reqPropertyClassify();
      this.propertyClassifyList = res.data?.propertyClassifyList || [];
    },
    // 商品类目
    reqGoodsClassify(params = {}) {
      return getCatList({ showHide: true, getData: true, userId: -1, ...params });
    },
    async getGoodsClassify(params = {}) {
      const res = await this.reqGoodsClassify(params);
      const data = (res && res.data && res.data[0]) || {};
      const list = [];
      const hdata = data.sellerCats || {};
      (data.subIds || []).forEach(idstr => {
        !idstr.includes('_') && hdata[idstr] && list.push(hdata[idstr]);
      });
      this.goodsClassifyList = list;
    },
    async getBrandList(params = {}) {
      const res = await queryBrandListAll(params);
      this.brandList = res.data?.list || [];
      this.brandListMap = this.brandList.reduce((pre, cur) => ({ ...pre, [cur.id]: cur }), {});
    },
  },
};

// 弹窗公共属性
export const dialogPropsMixin = {
  watch: {
    visible(v) {
      if (!v) return;
      this.initDialog && this.initDialog();
    },
  },
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: '',
    },
    value: {
      type: [Object, Array, String, Number],
      default: null,
    }
  }
};

// 库存上传
export const stockUploadDropdownList = {
  text: '库存上传',
  dropList: [
    { text: '批量库存上传', eventName: 'stockUpload_1' },
    { text: '批量配置库存自动上传', eventName: 'stockUpload_2' },
  ],
};
export const stockUploadMixin = {
  computed: {
    ...mapState({
      isStockUpload: state => {
        return /* state.user.userInfo.loginIdentity === 2 &&  */state.mixture.confModule.isStockUpload;
      },
    }),
  },
};
